export default "__VITE_ASSET__dc67526a__"